import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import type { ReactElement, ReactNode } from "react"
import { TooltipBorderedArrow } from "@/components/ui/tooltip-bordered-arrow"
import { cn } from "@/lib/utils"

type Props = {
  label?: ReactNode
  /** Rich content; wins over label when both set. */
  content?: ReactNode
  children: ReactElement
  className?: string
  /** Если не задан — берётся delayDuration ближайшего TooltipProvider. */
  delayDuration?: number
  /** Принудительно открыть (непрочитанный ответ). Без пропа — обычный ховер. */
  open?: boolean
  side?: "top" | "right" | "bottom" | "left"
  /** Wider panel for structured help. */
  contentClassName?: string
}

export function ActionHintTooltip({
  label,
  content,
  children,
  className,
  delayDuration,
  open,
  side = "top",
  contentClassName,
}: Props) {
  const body = content ?? label
  if (!body) return children

  return (
    <TooltipPrimitive.Root delayDuration={delayDuration} {...(open === undefined ? {} : { open })}>
      <TooltipPrimitive.Trigger asChild>
        {/* leading-none: иначе inline-flex наследует line-height и кнопки в тулбаре прыгают по высоте. */}
        <span className={cn("inline-flex h-full items-center leading-none", className)}>{children}</span>
      </TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={6}
          className={cn(
            "group z-[120] max-w-[16rem] rounded-lg border border-ui-border-opaque bg-ui-bg-elevated px-2.5 py-1.5 text-[11px] leading-relaxed text-ui-text-primary shadow-[var(--ui-shadow-md)]",
            content ? "max-w-xs whitespace-normal" : "whitespace-pre-line",
            contentClassName,
            "animate-in fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-1 data-[side=top]:slide-in-from-bottom-1",
          )}
        >
          {body}
          <TooltipBorderedArrow />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}
